import React, { useState, useEffect } from "react";
import { Formik,ErrorMessage, FieldArray  } from "formik";
import displayToastMessage from "../../../components/Common/Alert/displayToastMessage";
import Edit from "../../../assets/images/editinput.svg";
import dataTablesDataTables from "datatables.net-dt";
import * as Yup from "yup";
import PropTypes from "prop-types";
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp";
export default function RiskEdit(prop) {
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const { sendRequest: updateRiskRequest } = useHttp();
  const { vendors, classifications, updateBusinessAnalysis, reload, businessUsers } = prop;

  useEffect(() => {
    setInitialValues((oldValue) => {
      return { ...oldValue , 
          thirdPartyName: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.vendor_id
              : "",
          informationClassification: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.information_classification
              : "",
          serviceName: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.service_name
              : "",
          overViewoftheRisk: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.overview_oftherisk
              : "",
          businessOwner: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.business_owner
              : "",
          briefDescriptionOf: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.business_descriptionof_service
              : "",
          dateLogged: formatDate(prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.datelogged
              : ""
          ),
          duration: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.duration
              : "",
          dateIssued: formatDate(prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.date_issued
              : ""
          ),
          expiryDate: formatDate(prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.expiray_date
              : ""
          ),
          Contract: prop.updateBusinessAnalysis
          ? prop.updateBusinessAnalysis.risk_control:"",
  
          controldomain:prop.updateBusinessAnalysis
          ? prop.updateBusinessAnalysis.risk_domain:"",
  
          controlsubdomain:prop.updateBusinessAnalysis
          ? prop.updateBusinessAnalysis.risk_subdomain :"",
  
          addIssues: prop.updateBusinessAnalysis
          ? JSON.parse(prop.updateBusinessAnalysis.issues) :[]
      }
    })
  }, [prop.updateBusinessAnalysis])

  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
    let riskData = {
      riskId: updateBusinessAnalysis?.risk_id,
      vendor_id: Number(values.thirdPartyName),
      service_name: values.serviceName,
      service_description: values.briefDescriptionOf,
      business_owner: values.businessOwner,
      information_classification: Number(values.informationClassification),
      overview_oftherisk: values.overViewoftheRisk,
      issues: values.addIssues,
      workProgram_type:values.Contract,
      domain_value: values.controldomain,
      subDomain_value:values.controlsubdomain,
      date_logged: values.dateLogged,
      risk_duration: values.duration,
      date_issued: values.dateIssued,
      expiry_date: values.expiryDate,
      created_by: Number(sessionStorage.getItem("userId")),
      email:sessionStorage.getItem("email"),

    };
    try {
      updateRiskRequest(APIService.updateRiskRequest(riskData), (data) => {
        if (data.CODE) {
          resetForm();
          setLoading(false);
          prop.handleBack();
          reload();
          displayToastMessage(data.MSG, "success");
        } else {
          let Msg = "Action failed. Please try again!";
          setLoading(false);
          displayToastMessage(Msg, "error");
        }
      })
    } catch (error) {
      setLoading(false);
      let Msg = "Action failed. Please try again!";
      displayToastMessage(Msg, "error");
    }
  };
  let validationSchema = Yup.object().shape({
    thirdPartyName: Yup.string().required("Third party name is required").matches(/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/, "Only alphabets and numbers are allowed for this field "),
    informationClassification: Yup.string().required(
      "Information classification is required"
    ).matches(/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/, "Only alphabets and numbers are allowed for this field "),
    serviceName: Yup.string().required("Service name is required").matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ),
    overViewoftheRisk: Yup.string().required(
      "Over view of the risk is required"
    ).matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ),
    businessOwner: Yup.string().required("Business owner is required").matches(/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/, "Only alphabets and numbers are allowed for this field "),
    briefDescriptionOf: Yup.string().required(
      "Brief description of is required"
    ).matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ),
    Contract: Yup.string().required("Contract that cannot be Meet is required")
    .matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ),
    controldomain: Yup.string().required("Control Domain is required")
    .matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ),
    controlsubdomain: Yup.string().required("Control Sub Domain is required")
    .matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ),
    dateLogged: Yup.string().required("Please select date logged"),
    duration: Yup.string().required("duration is required").matches(/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/, "Only alphabets and numbers are allowed for this field "),
    dateIssued: Yup.string().required("Please select date issued"),
    expiryDate: Yup.string().required("Please select expiry date"),
    addIssues: Yup.array().of(
      Yup.object().shape({
        issue: Yup.string()
          .required("Please enter Role").matches(
            /^[a-zA-Z\d\-_.,&#()\s]+$/,
            "Only alphabets, numbers and some special characters are allowed for this field "
          ),
      })
    ),
  });
  function formatDate(date) {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  return (
    <Formik
      initialValues={{
        thirdPartyName: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.vendor_id
              : "",
          informationClassification: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.information_classification
              : "",
          serviceName: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.service_name
              : "",
          overViewoftheRisk: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.overview_oftherisk
              : "",
          businessOwner: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.business_owner
              : "",
          briefDescriptionOf: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.business_descriptionof_service
              : "",
          dateLogged: formatDate(prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.datelogged
              : ""
          ),
          duration: prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.duration
              : "",
          dateIssued: formatDate(prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.date_issued
              : ""
          ),
          expiryDate: formatDate(prop.updateBusinessAnalysis
              ? prop.updateBusinessAnalysis.expiray_date
              : ""
          ),
          Contract: prop.updateBusinessAnalysis
          ? prop.updateBusinessAnalysis.risk_control:"",
  
          controldomain:prop.updateBusinessAnalysis
          ? prop.updateBusinessAnalysis.risk_domain:"",
  
          controlsubdomain:prop.updateBusinessAnalysis
          ? prop.updateBusinessAnalysis.risk_subdomain :"",
  
          addIssues: prop.updateBusinessAnalysis
          ? JSON.parse(prop.updateBusinessAnalysis.issues) :[]
      }
      }
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {(props) => {
        const {
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
        } = props;
        return (
          <div className="create-vendor-form-container">
            <div className="row text-right pt-3">
              <div className="col-md-12">
                <span
                  className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
                  onClick={prop.handleBack}
                ></span>
              </div>
            </div>
            {loading ? (
              <div className="a-loading a-primary a-m-10 a-loading-24 spinner-alignment"></div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Third Party Name <span className="asterisk-required">*</span>
                      </label>
                      <select
                        className="cv-input-field"
                        type="text"
                        value={values.thirdPartyName}
                        onChange={handleChange("thirdPartyName")}
                        name="thirdPartyName"
                      >
                        <option key="0">Select Third Party Name</option>
                        {vendors?.map((each, index) => {
                            return (
                              <option key={index} value={each.vendor_id}>
                                {each.vendor_name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    {errors.thirdPartyName && touched.thirdPartyName && (
                      <div className="form-label error">
                        {errors.thirdPartyName}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Information Classification <span className="asterisk-required">*</span>
                      </label>
                      <select
                        className="cv-input-field"
                        type="text"
                        value={values.informationClassification}
                        onChange={handleChange("informationClassification")}
                        name="informationClassification"
                      >
                        <option key="0">
                          Select Information Classification
                        </option>
                        {classifications?.map((each, index) => {
                            return (
                              <option
                                key={index}
                                value={each.informationclassification_id}
                              >
                                {each.informationclassification_name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    {errors.informationClassification &&
                      touched.informationClassification && (
                        <div className="form-label error">
                          {errors.informationClassification}
                        </div>
                      )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="serviceRiskEdit" className="cv-input-label">
                        Service Name<span className="asterisk-required">*</span>
                      </label>
                      <input
                        className="cv-input-field pl-2"
                        onBlur={handleBlur}
                        id="serviceRiskEdit"
                        type="text"
                        placeholder="Please enter service name"
                        value={values.serviceName}
                        onChange={handleChange("serviceName")}
                        name="serviceName"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.serviceName && touched.serviceName && (
                      <div className="form-label error">
                        {errors.serviceName}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="overviewRiskEdit" className="cv-input-label">
                        Over View of the Risk <span className="asterisk-required">*</span>
                      </label>
                      <input
                        className="cv-input-field pl-2"
                        onBlur={handleBlur}
                        id="overviewRiskEdit"
                        type="text"
                        placeholder="Please enter over view of the risk"
                        value={values.overViewoftheRisk}
                        onChange={handleChange("overViewoftheRisk")}
                        name="overViewoftheRisk"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.overViewoftheRisk && touched.overViewoftheRisk && (
                      <div className="form-label error">
                        {errors.overViewoftheRisk}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Business Owner <span className="asterisk-required">*</span>
                      </label>
                      <select
                        className="cv-input-field"
                        type="text"
                        value={values.businessOwner}
                        onChange={handleChange("businessOwner")}
                        name="businessOwner"
                      >
                        <option key="0">Select Business User</option>
                        {businessUsers?.map((each, index) => {
                            return (
                              <option key={index} value={each.user_id}>
                                {each.user_name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    {errors.businessOwner && touched.businessOwner && (
                      <div className="form-label error">
                        {errors.businessOwner}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="descriptionRiskEdit" className="cv-input-label">
                        Brief Description of <span className="asterisk-required">*</span>
                      </label>
                      <input
                        className="cv-input-field pl-2"
                        onBlur={handleBlur}
                        id="descriptionRiskEdit"
                        type="text"
                        placeholder="Please enter brief description of"
                        value={values.briefDescriptionOf}
                        onChange={handleChange("briefDescriptionOf")}
                        name="briefDescriptionOf"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.briefDescriptionOf &&
                      touched.briefDescriptionOf && (
                        <div className="form-label error">
                          {errors.briefDescriptionOf}
                        </div>
                      )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="loggedRiskEdit" className="cv-input-label">
                        Date Logged<span className="asterisk-required">*</span>
                      </label>
                      <input
                        className="cv-input-field pl-1"
                        onBlur={handleBlur}
                        id="loggedRiskEdit"
                        type="date"
                        value={values.dateLogged}
                        onChange={handleChange("dateLogged")}
                        name="dateLogged"
                      />
                    </div>
                    {errors.dateLogged && touched.dateLogged && (
                      <div className="form-label error">
                        {errors.dateLogged}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="durationRiskEdit" className="cv-input-label">
                        Duration<span className="asterisk-required">*</span>
                      </label>
                      <input
                        className="cv-input-field pl-2"
                        onBlur={handleBlur}
                        id="durationRiskEdit"
                        type="Number"
                        placeholder="Please enter duration"
                        value={values.duration}
                        onChange={handleChange("duration")}
                        name="duration"
                      />
                    </div>
                    {errors.duration && touched.duration && (
                      <div className="form-label error">{errors.duration}</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="dateIssuesRiskEdit" className="cv-input-label">
                        Date Issued<span className="asterisk-required">*</span>
                      </label>
                      <input
                        className="cv-input-field pl-1"
                        onBlur={handleBlur}
                        id="dateIssuesRiskEdit"
                        type="date"
                        value={values.dateIssued}
                        onChange={handleChange("dateIssued")}
                        name="dateIssued"
                      />
                    </div>
                    {errors.dateIssued && touched.dateIssued && (
                      <div className="form-label error">
                        {errors.dateIssued}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="expiryRiskEdit" className="cv-input-label">
                        Expiry Date<span className="asterisk-required">*</span>
                      </label>
                      <input
                        className="cv-input-field pl-1"
                        onBlur={handleBlur}
                        id="expiryRiskEdit"
                        type="date"
                        value={values.expiryDate}
                        onChange={handleChange("expiryDate")}
                        name="expiryDate"
                      />
                    </div>
                    {errors.expiryDate && touched.expiryDate && (
                      <div className="form-label error">
                        {errors.expiryDate}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                <div className="col-sm-6">
                  <div className="cv-input-field-container">
                    <label htmlFor="controlRiskEdit" className="cv-input-label">
                      Control/Question <span className="asterisk-required">*</span>
                    </label>
                    <input
                      onBlur={handleBlur}
                      id="controlRiskEdit"
                      className="cv-input-field"
                      type="text"
                      onChange={handleChange("Contract")}
                      value={values.Contract}
                      name="Contract"
                      placeholder="Enter Control/Question"
                    />
                    <img alt="edit" src={Edit} className="edit-input" />
                  </div>
                  {errors.Contract && touched.Contract && (
                    <div className="form-label error">{errors.Contract}</div>
                  )}
                </div>
                <div className="col-sm-6">
                  <div className="cv-input-field-container">
                    <label htmlFor="domainRiskEdit" className="cv-input-label">
                       Domain/Area<span className="asterisk-required">*</span>
                    </label>
                    <input
                      onBlur={handleBlur}
                      id="domainRiskEdit"
                      className="cv-input-field"
                      onChange={handleChange("controldomain")}
                      type="text"
                      value={values.controldomain}
                      name="controldomain"
                      placeholder="Enter domain/area"
                    />
                    <img alt="edit" src={Edit} className="edit-input" />
                  </div>
                  {errors.controldomain && touched.controldomain && (
                    <div className="form-label error">
                      {errors.controldomain}
                    </div>
                  )}
                </div>
                
                </div>
                <div className="row"> 
                <div className="col-sm-6">
                  <div className="cv-input-field-container">
                    <label htmlFor="subRiskEdit" className="cv-input-label">
                      Sub-Domain/Sub-Area <span className="asterisk-required">*</span>
                    </label>
                    <input
                      onBlur={handleBlur}
                      id="subRiskEdit"
                      className="cv-input-field"
                      onChange={handleChange("controlsubdomain")}
                      type="text"
                      value={values.controlsubdomain}
                      name="controlsubdomain"
                      placeholder="Enter sub-domain/area"
                    />
                    <img alt="edit" src={Edit} className="edit-input" />
                  </div>
                  {errors.controlsubdomain && touched.controlsubdomain && (
                    <div className="form-label error">
                      {errors.controlsubdomain}
                    </div>
                  )}
                </div>
                <div className="col-sm-6">
                <FieldArray
        name="addIssues"
        render={(arrayHelpers) =>
          values.addIssues.map((item, index) => {
            return (
              <div key={index} className="row"> 
              <div className="col-sm-10">
                  <div className="cv-input-field-container">
                    <label className="cv-input-label">
                      issues <span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field leftPadding"
                      type="text"
                      value={values.addIssues[index].issue}
                      onChange={handleChange(
                        `addIssues[${index}].issue`
                      )}
                      name="issue"
                      placeholder={"Add Issue"}
                      //disabled={disabledFields}
                    />
                    <img alt="edit" src={Edit} className="edit-input" />
                  </div>
                  <span style={{ color: "#ff0000" }}>
                    {" "}
                    <ErrorMessage
                      name={`addIssues[${index}].issue`}
                    />
                  </span>  
             </div>
             {index === dataTablesDataTables.length - 1 ? (
                  <div className="col-sm-1 mt-1">
                    <span
                      onClick={() =>
                        arrayHelpers.push({
                          issue: "",
                        })
                      }
                      className="Appkit4-icon icon-circle-plus-outline pointer add-fill"
                    ></span>
                    {index === dataTablesDataTables.length - 1 &&
                      values.addIssues.length > 1 ? (
                      <span
                        onClick={() => arrayHelpers.pop()}
                        className="Appkit4-icon icon-circle-minus-outline pointer add-fill mt-1"
                      ></span>
                    ) : null}
                  </div>
                ) : null}
             </div>
            );
          })
        }
      />
      </div>
 </div>
                <div className="options-container">
                  <button
                    type="submit"
                    className="save-button "
                    disabled={isSubmitting}
                  >
                    Update
                  </button>
                  <button
                    className="cancel-button m-l-2"
                    type="reset"
                    onClick={prop.handleBack}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            )}
          </div>
        );
      }}
    </Formik>
  );
}

RiskEdit.propTypes = {
  values: PropTypes.any,
  touched: PropTypes.any,
  errors: PropTypes.any,
  isSubmitting: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
}